import React from "react";

// icons
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";
// estilo em src/assets/scss/paper-dashboard/_historico-analise.scss, importado via paper-dashboard.scss

export default function HistoricoAnalise({ historico }) {
    return (
        <div className="contentGroup">
            <h5 className="subtitleCardInfo">Histórico de Ações Executadas</h5>
            <div className="historicoTimeline">
                {historico && historico.map((m, key) => (
                    <div className="historicoTimelineItem" key={key}>
                        <span className="historicoTimelineMarker">
                            <FiberManualRecordIcon fontSize="inherit" />
                        </span>
                        <div className="historicoTimelineContent">
                            <div className="historicoTimelineHeader">
                                <span className="historicoTimelineStatus">{m.situacaoAnalise}</span>
                                <span className="historicoTimelineData">{formateDateandTime(m.dataHora)}</span>
                            </div>
                            <div className="historicoTimelineRow"><strong>Ação Executada: </strong>{m.acao}</div>
                            <div className="historicoTimelineRow"><strong>Usuário: </strong>{m.usuario_Nome}</div>
                            {m.situacaoAnalise === "Aguardando Publicação" &&
                                <div className="historicoTimelineRow"><strong>Número SEI: </strong>{m.numeroProcesso}</div>
                            }
                            <div className="historicoTimelineRow"><strong>Observações: </strong>{m.observacao}</div>
                            {m.prazoResponsividadeExcedido &&
                                <div className="historicoTimelineAlerta text-danger">* Prazo de Responsividade Excedido</div>
                            }
                            {m.anexos?.length > 0 &&
                                <div className="historicoTimelineAnexos">
                                    <strong>Anexos: </strong>
                                    {m.anexos.map((n, key2) => (
                                        <a key={key2} className="historicoTimelineAnexo" target="_blank" rel="noopener noreferrer" href={n.anexo}>
                                            <i className="fas fa-file-export"></i> {n.tipoAnexo}
                                        </a>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
